import { Box, styled, useTheme } from '@mui/material';

import { Tooltip, Typography } from '@zendesk/forethought-elements';
import { VoiceTranscript } from './types';
import { getTranscriptTime } from './utils';

// TODO: localize when useTranslation migration reaches voice drawer
const WIDGET_LABELS: Record<string, string> = {
  buttons: 'Triggered component: Button',
  dynamic_card: 'Triggered component: Dynamic Card',
  form: 'Triggered component: Form',
};

export const InteractiveWidgetTranscript = ({
  startTime,
  transcript,
}: {
  startTime: number;
  transcript: VoiceTranscript;
}) => {
  const { palette } = useTheme();
  const timestamp = getTranscriptTime(
    startTime,
    transcript.start_timestamp || 0,
  );
  const label =
    WIDGET_LABELS[transcript.widget_type || ''] || 'Triggered component';

  return (
    <Tooltip fullWidth placement='top' tooltipContent={timestamp}>
      <TriggeredLabel>
        <Typography color={palette.colors.grey[600]} variant='font12'>
          {label}
        </Typography>
      </TriggeredLabel>
    </Tooltip>
  );
};

const TriggeredLabel = styled(Box)`
  border: 1px solid ${props => props.theme.palette.colors.slate[200]};
  border-radius: 8px;
  padding: 8px 12px;
`;
